import { BackendWrapper } from '../BackendWrapper';
import { SessionWrapperContext } from './externalContext';
import { WrapperBuilder } from '../../builders/wrapperBuilder';
import { wrapperIdentifier } from './common';
import {
  ComponentWrapperProps,
  InternalContextVariables,
  ExternalContextVariables,
  InternalContextFunctions,
  ExternalContextFunctions,
  ContextState,
  Virtuals,
  Statics,
  BindedWrapperProperties,
} from './interfaces';

export const wrapperBuilder = new WrapperBuilder<
  ComponentWrapperProps,
  InternalContextVariables,
  {},
  ExternalContextVariables,
  InternalContextFunctions,
  {},
  ExternalContextFunctions,
  ContextState,
  Virtuals,
  Statics,
  BindedWrapperProperties,
  {}
>(
  wrapperIdentifier,
  wrapperIdentifier,
  [BackendWrapper],
  SessionWrapperContext
);
